/* @flow */

import { combineReducers } from 'redux';
import gridClientesReducer from './grid-clientes';
import enderecoReducer from './endereco';
import gridEnderecosReducer from './grid-enderecos';
import gridProdutosReducer from './grid-produtos';
import itensReducer from './itens';
import clienteReducer from './cliente';
import detalhesProdutoReducer from './detalhes-produto';
import cadastroClienteReducer from './cadastro-cliente';
import cadastroEnderecoReducer from './cadastro-endereco';
import pedidoReducer from './pedido';
import finalizacaoReducer from './finalizacao';

export default combineReducers({
    cliente: clienteReducer,
    itens: itensReducer,
    endereco: enderecoReducer,
    detalhesProduto: detalhesProdutoReducer,
    gridClientes: gridClientesReducer,
    gridEnderecos: gridEnderecosReducer,
    gridProdutos: gridProdutosReducer,
    cadastroCliente: cadastroClienteReducer,
    cadastroEndereco: cadastroEnderecoReducer,
    pedido: pedidoReducer,
    finalizacao: finalizacaoReducer,
});
